import {Signaalkaart} from './signaalkaart';
import * as lodash from 'lodash';

export class Signaalkaarten {

  static of(signaalkaarten: Array<Signaalkaart>): Signaalkaarten {
    return new Signaalkaarten(signaalkaarten);
  }

  constructor(private signaalkaarten: Array<Signaalkaart>) {
  }

  getSignaalkaarten(): Array<Signaalkaart> {
    return this.signaalkaarten;
  }

  getLaatsteVersieSignaalkaarten(): Array<Signaalkaart> {
    return lodash.chain(this.signaalkaarten)
      .groupBy(signaalkaart => signaalkaart.getId())
      .mapValues(signaalkaartenWithSameId => lodash.maxBy(signaalkaartenWithSameId, signaalkaart => signaalkaart.getVersie()) as Signaalkaart)
      .flatMap()
      .value();
  }

  findSignaalkaartWithId(id: string): Signaalkaart {
    return this.signaalkaarten
      .find(signaalkaart => signaalkaart.hasId(id));
  }

  getSignaalkaartWithIdAndVersie(id: string, versie: number): Signaalkaart {
    return this.signaalkaarten.find(signaalkaart => signaalkaart.hasId(id) && signaalkaart.hasVersie(versie));
  }

  isEmpty(): boolean {
    return this.signaalkaarten.length === 0;
  }
}
